import type { ReactElement } from 'react';
import React from 'react';

import { BackToGameConnected as CoreBTG } from '@pp/core/src/components/backToGame/BackToGameConnected';
import { BackToGameHolder } from '@pp/core/src/components/backToGame/BackToGameHolder';
import { useConfigSlice } from '@pp/core/src/store/slices/config/selectors';

export const BackToGameConnected = (): ReactElement => {
  const config = useConfigSlice.casinoConfig();
  const session = useConfigSlice.session();
  const isSlotsLobby = useConfigSlice.getIsSlotsLobby() || (!!config?.slotsLobbyEnabled && !session?.launchSource);
  return (
    <>
      {isSlotsLobby ? null : (
        <BackToGameHolder>
          <CoreBTG />
        </BackToGameHolder>
      )}
    </>
  );
};
